import { HomepageJsonLd } from '../../jsonld/HomepageJsonLd';
import { WidgetConsumerPageContent } from 'components/www/WidgetConsumerPageContent';
import { currentMetroAreaSelector } from 'selectors/metroAreaSelectors';
import { customDimensions } from 'utils/Analytics';
import { googleAnalyticsScriptsLoadedSelector } from 'selectors/cookieConsentSelectors';
import { useActions } from '@tock/shared/utils/connect';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMountEffect } from '@tock/hooks';
import { useQueryStringParams } from 'hooks/useQueryStringParams';
import { useSelector } from 'react-redux';
import SearchTubeHero from 'components/hero/SearchTubeHero';
import clsx from 'clsx';

const CustomConsumerPageRoute = () => {
  const { pathname } = useLocation();
  const queryStringParams = useQueryStringParams<{ tock_source?: string; tock_medium?: string }>();
  const isGaScriptLoaded = useSelector(googleAnalyticsScriptsLoadedSelector);
  const {
    actions: { navigation },
  } = useActions();

  useMountEffect(() => {
    navigation.set({
      title: '',
      hasLogo: true,
    });
  });

  useEffect(() => {
    if (queryStringParams.tock_medium && queryStringParams.tock_source && isGaScriptLoaded) {
      window.analytics.setDimensionInTockOnly(
        customDimensions.TOCK_SOURCE,
        queryStringParams.tock_source
      );
      window.analytics.setDimensionInTockOnly(
        customDimensions.TOCK_MEDIUM,
        queryStringParams.tock_medium
      );
    }
  }, [queryStringParams.tock_source, queryStringParams.tock_medium, isGaScriptLoaded]);

  const currentMetroArea = useSelector(currentMetroAreaSelector);

  const isHome = pathname === '/';

  return (
    <>
      {isHome ? <HomepageJsonLd /> : null}
      <div className={clsx('PageContent PageContent--page-widget PageContentWidgetContainer')}>
        {isHome && <SearchTubeHero metroArea={currentMetroArea} />}
        <WidgetConsumerPageContent pathname={pathname} standAlone={!isHome} />
      </div>
    </>
  );
};

export default CustomConsumerPageRoute;
